<template>
  <div v-if="showNotification" class="notification-container">
    <div class="notification-wrapper">
      <div v-if="title" class="notification-title">{{ title }}</div>
      <div class="notification-description">{{ description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notification',
  props: {
    duration: {
      type: Number,
      default: 4000,
    },
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showNotification: false,
      timer: null,
    };
  },
  mounted() {},
  methods: {
    startTimer() {
      this.showNotification = true;

      if (this.duration > 0 && this.showNotification) {
        this.timer = setTimeout(() => {
          this.showNotification = false;
        }, this.duration);
      }
    },
  },
  watch: {
    show: {
      immediate: true,
      handler: function (value) {
        if (value) {
          this.startTimer();
        }
      },
    },
  },
  destroyed() {
    clearTimeout(this.timer);
    this.showNotification = false;
  },
};
</script>

<style lang="stylus" scoped>
.notification
  &-container
    border-right 10px
    position absolute
    z-index 1010
    pointer-events none
    box-sizing border-box
    display flex
    flex-direction column
    align-items center
    top 89px
    left 0
    width 100%

  &-wrapper
    background-color white
    display inline-block
    min-width 948px
    max-width 1160px
    min-height 153px
    border-radius 21px
    text-align center
    padding 38px 48px

  &-title
    letter-spacing 0.7px

  &-description
    letter-spacing 0.7px
    text-transform lowercase

    &:first-letter
      text-transform: uppercase
</style>
